// ── Map tile providers ────────────────────────────────────────────────────────
// All maps in the app read their tile URL from the global map layer setting
// stored in the UI store (persisted to localStorage).

export type MapLayerKey =
  | 'google_road'
  | 'google_satellite'
  | 'google_hybrid'
  | 'google_traffic'
  | 'osm'

export interface MapTileConfig {
  label:       string
  group:       string
  url:         string
  subdomains?: string
  attribution: string
}

export const MAP_TILES: Record<MapLayerKey, MapTileConfig> = {
  google_road: {
    label:      'Google Maps',
    group:      'Google',
    url:        'https://mt{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
    subdomains: '0123',
    attribution: '© Google Maps',
  },
  google_satellite: {
    label:      'Satellite',
    group:      'Google',
    url:        'https://mt{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
    subdomains: '0123',
    attribution: '© Google Maps',
  },
  google_hybrid: {
    label:      'Hybrid',
    group:      'Google',
    url:        'https://mt{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
    subdomains: '0123',
    attribution: '© Google Maps',
  },
  google_traffic: {
    label:      'Traffic',
    group:      'Google',
    url:        'https://mt{s}.google.com/vt/lyrs=m@221097413,traffic&x={x}&y={y}&z={z}',
    subdomains: '0123',
    attribution: '© Google Maps',
  },
  osm: {
    label:      'OpenStreetMap',
    group:      'Open',
    url:        'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    subdomains: 'abc',
    attribution: '© OpenStreetMap contributors',
  },
}

export const DEFAULT_MAP_LAYER: MapLayerKey = 'google_road'

/** All layer keys in display order */
export const MAP_LAYER_KEYS = Object.keys(MAP_TILES) as MapLayerKey[]
